<script setup>
import EditableTextField from "../../../portal-editable-fields/EditableTextField.vue";
import {computed} from "vue";
import {usePortalContentAndDesignStore} from "../../../../../stores/partners/portalContentAndDesignStore";
import {useRoute} from "vue-router";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const props = defineProps({
    headingClasses: {
        type: [String, Array],
        default: 'text-xl sm:text-2xl lg:text-3xl font-semibold text-opacity-100',
    },
    subheadingClasses: {
        type: [String, Array],
        default: 'text-opacity-75 text-sm mt-2',
    },
    containerClasses: {
        type: [String, Array],
        default: '',
    },
});


const currentRoute = useRoute();

const headingMap = {
    dashboard: 'portal_translation_pages_hello',
    resources: 'portal_translation_pages_resources',
    referrals: 'portal_translation_pages_referrals',
    leads: 'portal_translation_pages_leads',
    payouts: 'portal_translation_pages_payouts',
    reports: 'portal_translation_pages_reporting',
    messages: 'portal_translation_pages_messages'
};

const subheadingMap = {
    dashboard: 'portal_translation_pages_find_program_sum',
    resources: 'portal_translation_pages_customize_options_line',
    referrals: 'portal_translation_pages_see_referral_activity',
    leads: 'portal_translation_pages_leads_activity_or_search',
    payouts: 'portal_translation_pages_review_line',
    reports: 'portal_translation_pages_tracking_line',
    messages: 'portal_translation_pages_messages_description'
};

const defaultHeadings = {
    messages: 'Messages'
};

const defaultSubheadings = {
    messages: 'View important updates and announcements about your affiliate program.'
};

const pageHeading = computed({
    get() {
        const key = headingMap[currentRoute.name];
        if (key === 'portal_translation_pages_hello') {
            return portalContentAndDesignStore.translationSettings[key] + ', ' + portalContentAndDesignStore.authUser?.name;
        }
        return key ? (portalContentAndDesignStore.translationSettings[key] || defaultHeadings[currentRoute.name] || '') : '';
    },
    set(value) {
        const key = headingMap[currentRoute.name];
        if (key) portalContentAndDesignStore.translationSettings[key] = value;
    }
});

const pageSubheading = computed({
    get() {
        const key = subheadingMap[currentRoute.name];
        return key ? (portalContentAndDesignStore.translationSettings[key] || defaultSubheadings[currentRoute.name] || '') : '';
    },
    set(value) {
        const key = subheadingMap[currentRoute.name];
        if (key) portalContentAndDesignStore.translationSettings[key] = value;
    }
});

</script>

<template>
    <div :class="containerClasses">
        <div class="flex items-center justify-between gap-4">
            <div class="flex-1 min-w-0">
                <editable-text-field
                    v-model="pageHeading"
                    text-type="h1"
                    :class="[
                        headingClasses,
                        portalContentAndDesignStore.getTextColorClass
                    ]"
                />
                <editable-text-field
                    v-if="pageSubheading"
                    v-model="pageSubheading"
                    text-type="p"
                    :class="[
                        subheadingClasses,
                        portalContentAndDesignStore.getTextColorClass
                    ]"
                />
            </div>
            <!-- Teleport target for page actions -->
            <div id="header-page-actions"></div>
        </div>
    </div>
</template>

